import { Component } from "react";
import Icon from "@mui/material/Icon/Icon";
import Tooltip from "@mui/material/Tooltip";
import {
    getColorFromStatusLabel,
    getIconNameFromStatusLabel,
    formatStatus,
} from "../../../redux/intervention/extranetInterventionStatus";
import "../../../statusIcon.css";
import { getCurrentFunctionName } from "../../../performanceModeManager";

class InterventionStatusIcon extends Component {
    render() {
        console.perfLog(getCurrentFunctionName());
        let iconElement;

        iconElement = (
            <Icon
                className={
                    this.props.className +
                    " status-icon-color-" +
                    getColorFromStatusLabel(this.props.state, this.props.internalState, this.props.lowlight)
                }
            >
                {getIconNameFromStatusLabel(this.props.state, this.props.internalState)}
            </Icon>
        );

        return <Tooltip title={formatStatus(this.props.state, this.props.internalState)}>{iconElement}</Tooltip>;
    }
}

export default InterventionStatusIcon;
